<template>
    <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">

        <!-- Side Menu -->
        <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
            <!-- Top Menu -->
            <div class="sticky top-0 bg-[#090446] p-4 z-20">
                <div>
                    <p class="text-lg font-semibold">Total Progress: {{
                        progressDetail.totalAnswers1}}/{{
                            progressDetail.totalQuestions1}}
                    </p>
                    <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                        <div class="bg-[#ab064e] h-2.5 rounded-full"
                            :style="{ width: ((progressDetail.totalAnswers1) / (progressDetail.totalQuestions1)) * 100 + '%' }">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bottom Menu -->
            <div class="mt-auto">
                <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
                    Privacy Policy
                </router-link>
            </div>
        </div>

        <!-- Main Content -->
        <div class="flex-1 flex items-center justify-center py-6 md:px-16 px-0 z-0">
            <div id="welcome-card"
                class="w-full sm:max-w-md lg:max-w-lg mx-auto px-6 py-8 z-20 bg-white rounded-[36px] shadow-lg">
                <!-- Logo -->
                <div class="flex items-center justify-center mb-6">
                    <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
                </div>

                <div v-if="welcome">

                    <!-- Description -->
                    <div class="text-center text-black text-lg mb-4">
                        <b>Instructions Message:</b>
                    </div>
                    <div class="text-black mb-8">
                        <p class="text-lg">Thank you for your willingness to take the assessment. Here's how it works:
                        </p>
                    </div>

                    <!-- Icon Rows -->
                    <div class="space-y-4">
                        <div class="flex items-center">
                            <div class="text-black text-lg">
                                <b>1. Read each statement carefully:</b> You will be presented with a series of
                                statements about your thoughts, behaviors, and feelings regarding change and
                                uncertainty.
                            </div>
                        </div>

                        <div class="flex items-center">
                            <div class="text-black text-lg">
                                <b>2. Rate your agreement with each statement:</b> For each statement, choose the
                                response that best reflects your current perspective. The scale is as follows:
                                <ul>
                                    <li><strong>Strongly Disagree (1)</strong></li>
                                    <li><strong>Somewhat Disagree (2)</strong></li>
                                    <li><strong>Neutral (3)</strong></li>
                                    <li><strong>Somewhat Agree (4)</strong></li>
                                    <li><strong>Strongly Agree (5)</strong></li>
                                </ul>
                            </div>
                        </div>

                        <div class="flex items-center">
                            <div class="text-black text-lg">
                                <b>3. Be honest and thoughtful:</b> Your responses are completely confidential and will
                                provide you with valuable insights into your approach to change. There are no right or
                                wrong answers—just your honest reactions.
                            </div>
                        </div>
                        <div class="flex items-center">
                            <div class="text-black text-lg">
                                <b>4. Focus and avoid distractions:</b> To ensure the most accurate results, try to
                                complete the assessment in one sitting, free from distractions.
                            </div>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <button @click.prevent="handleContinue"
                        class="relative mt-5 flex items-center justify-center w-full py-2 text-lg text-white bg-[#0A0446] hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 h-10 py-2.5 text-center">
                        <svg v-if="isLoading" class="animate-spin h-5 w-5 text-white absolute"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                        </svg>
                        <span v-else>Begin Assessment</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import Api from '../router/api'
import AppMixin from '../mixins/AppMixin'
export default {
    name: 'SurveyConsent',
    data() {
        return {
            url: '',
            agree: false,
            instructions: false,
            disagree: false,
            welcome: true,
            user_name: '',
            progressDetail: {
                totalQuestions1: 0,
                totalAnswers1: 0,
            },
            isLoading: 0
        }
    },
    mounted() {
        let urlToken = this.$route.fullPath.split('/')[2]
        this.url = urlToken
        this.getProgressBarDetail(this.url);
        this.getInvitedUser()
    },
    methods: {
        getInvitedUser: function () {
            Api.getInvitedUser(this.url).then(response => {
                this.user_name = response.data.res.name;
            }
            );
        },
        getProgressBarDetail(url) {
            Api.getAssessmentProgress(url).then(response => {
                this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
                this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
            });
        },
        handleContinue: function () {
            let that = this
            that.isLoading = 1;
            Api.updateSteps(that.url, 2);
            this.$router.push(`/assessment-survey/${this.url}`);

        },
        submitConsent() {
            this.instructions = true;
            this.welcome = false;
        },
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 1rem;
}

.err {
    color: red;
}
</style>
0


// WEBPACK FOOTER //
// src/components/AssessmentInstruction.vue